import styled from 'styled-components';

export const NotValueBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > img {
    flex-shrink: 0;
    margin-left: 8px;
  }
`;
